import { type ConfigSection, type GameProfile, type Menu, MenuItem, type ProfileCtx } from "./types";
import defaultProfile, { asyncRoute } from "@/game_profiles/default";
import { commonMenuItems } from "@/game_profiles/common";
import { usePermissions } from "@/util/permissions";
import { faPuzzlePiece } from "@fortawesome/pro-solid-svg-icons";
import { useServiceStore } from "@/store/service";
import { usePropertyBuilder } from "@/components/views/config/helpers";
import { computed } from "vue";
import type { DeadsideProfileNamespace, SteamWorkshopItem } from "@/graphql";
import { useSteamWorkshop } from "@/components/views/mods/steam_workshop";
import type { IUseMods } from "@/components/views/mods";

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "basic" } },
  { component: "ConfSection", props: { name: "map" } },
];

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  const { isAdmin } = usePermissions();
  if (isAdmin.value) {
    menu[0].items.push(commonMenuItems.logs);
    menu[0].items.push(commonMenuItems.console);
  }
  menu[0].items.push(
    new MenuItem(
      "mods",
      faPuzzlePiece,
      asyncRoute(() => import("../components/views/config/deadside/Mods.vue")),
      [
        {
          route: "manage",
          component: asyncRoute(() => import("../components/views/mods/manage/ModsManage.vue")),
        },
      ],
    ),
  );
  return menu;
};

export function useMods() {
  const service = useServiceStore();
  const { buildProperty } = usePropertyBuilder();
  const { buildConfig } = usePropertyBuilder();

  const profile = computed(() => service.ctx.profile as DeadsideProfileNamespace | undefined);
  const selectedWorkshopItems = computed(() => profile.value?.selectedWorkshopItems ?? []);
  const subscribedFileIds = buildProperty<Array<string>>("virtual", "mods", []);
  const subscribedCollectionIds = buildConfig<Array<string>>("subscribedCollectionIds", []);
  return useSteamWorkshop(selectedWorkshopItems, subscribedFileIds, subscribedCollectionIds);
}

export default (_ctx: ProfileCtx): Partial<GameProfile<SteamWorkshopItem, IUseMods<SteamWorkshopItem>>> => ({
  configSections,
  useMods,
  menu: createMenu(),
});
